import React from 'react';

import RequireAuth from './components/RequireAuth';

export default function requireAuth(Component) {
    return () => (
        <RequireAuth>
            <Component />
        </RequireAuth>
    );
}